import type { Agent } from '../types';

const STORAGE_KEY = 'dfs_agent_user';

// Demo agents for the backoffice
const DEMO_AGENTS: Agent[] = [
  {
    agent_id: 'AGT-001',
    email: 'admin@dfscollections.com',
    first_name: 'System',
    last_name: 'Admin',
    role: 'admin',
    department: 'IT',
    active: true,
  },
  {
    agent_id: 'AGT-002',
    email: 'supervisor@dfscollections.com',
    first_name: 'Maria',
    last_name: 'Rodriguez',
    role: 'supervisor',
    department: 'Collections',
    active: true,
  },
  {
    agent_id: 'AGT-003',
    email: 'agent@dfscollections.com',
    first_name: 'John',
    last_name: 'Smith',
    role: 'agent',
    department: 'Collections',
    active: true,
  },
];

class AuthService {
  login(email: string, password: string): Agent | null {
    // Demo authentication - in production this would validate against a real auth system
    if (password !== 'demo123') {
      return null;
    }

    const agent = DEMO_AGENTS.find(a => a.email.toLowerCase() === email.toLowerCase());
    if (agent && agent.active) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(agent));
      return agent;
    }

    return null;
  }

  logout(): void {
    localStorage.removeItem(STORAGE_KEY);
  }

  getCurrentUser(): Agent | null {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored) as Agent;
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    return null;
  }

  getDemoCredentials(): { email: string; role: string }[] {
    return DEMO_AGENTS.map(a => ({
      email: a.email,
      role: a.role,
    }));
  }

  isAdmin(user: Agent): boolean {
    return user.role === 'admin';
  }

  isSupervisor(user: Agent): boolean {
    return user.role === 'supervisor' || user.role === 'admin';
  }
}

export const authService = new AuthService();
